import { useModuleGate } from '../lib/moduleGate';

/**
 * True when the unified Plan of Record narrative surface is on: the cycle's
 * linked narrative record renders as a plan subpage
 * (/planning/plans/:cycleId/narrative) with a summary card on the plan
 * overview, and standalone narrative URLs for cycle-linked records redirect
 * there. Canonical gate (§2.7): plan_narrative workspace module + flag.
 * See DEPRECATION_REGISTER DEP-026.
 */
export function usePlanNarrativeEnabled(): boolean {
  return useModuleGate('plan_narrative');
}
